"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_CLEV = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F1F9FC" },
          100: { value: "#C5E5F5" },
          200: { value: "#92CEEC" },
          300: { value: "#4FB0E0" },
          400: { value: "#279DD9" },
          500: { value: "#0084C5" },
          600: { value: "#006FA7" },
          700: { value: "#005986" },
          800: { value: "#004C72" },
          900: { value: "#003752" },
        },
        secondary: {
          50: { value: "#FFF0DD" },
          100: { value: "#FADBB4" },
          200: { value: "#F4C888" },
          300: { value: "#EEB75B" },
          400: { value: "#EAB046" },
          500: { value: "#EAA82F" },
          600: { value: "#D08315" },
          700: { value: "#A25B0E" },
          800: { value: "#753908" },
          900: { value: "#461D00" },
        },
      },
    },
  },
});
